import React, { useState, useEffect } from 'react'

import { getRelativeBasePath } from '../../global/environments/path'

export default function DisclosureModal() {
  const STORAGE_KEY = 'CM_Institutional_Disclaimer'
  const CTI_URL = 'https://www.columbiathreadneedleus.com/'

  const EXPIRY_TIME = 60 * 60 * 24 * 30 // 30 days in seconds

  const [showModal, setShowModal] = useState(false)
  const [privateCheckSelected, setPrivateCheckSelected] = useState(true)

  useEffect(() => {
    let disclaimerAccepted

    try {
      disclaimerAccepted =
        window.sessionStorage.getItem(STORAGE_KEY) ||
        new Date().getTime() <= window.localStorage.getItem(STORAGE_KEY)
      /* eslint-disable-next-line no-empty */
    } catch (e) {}

    if (!disclaimerAccepted && window.location === window.parent.location) {
      setShowModal(true)
    }
  }, [])

  const handleCheck = () => {
    setPrivateCheckSelected(!privateCheckSelected)
  }

  const handleClick = () => {
    try {
      if (privateCheckSelected) {
        window.sessionStorage.removeItem(STORAGE_KEY)
        window.localStorage.setItem(
          STORAGE_KEY,
          new Date().getTime() + 1000 * EXPIRY_TIME
        )
      } else {
        window.localStorage.removeItem(STORAGE_KEY)
        window.sessionStorage.setItem(STORAGE_KEY, true)
      }
      /* eslint-disable-next-line no-empty */
    } catch (e) {}

    setShowModal(false)
  }

  return (
    showModal && (
      <>
        <div className="modal-overlay" />
        <div className="modal-wrapper" aria-modal tabIndex={-1} role="dialog">
          <div className="modal Content">
            <div className="u-flex u-flexAlignItemsCenter u-marginBottom5gu">
              <h3 className="u-flexAuto u-textSizeMsrp3 u-textUppercase">
                Welcome to the Columbia Threadneedle Investments U.S.
                Institutional Website
              </h3>
            </div>
            <div className="u-marginBottom5gu">
              <p className="u-sm-textSizeMsrm1">
                <span className="u-textBold">
                  This site is exclusively intended for institutional investors
                  and consultants.{' '}
                </span>
                Columbia Management Investment Advisers, LLC (CMIA) offers asset
                management and investment advisory services to institutional
                investors through various strategies and investment vehicles. If
                you are not an institutional investor or consultant or would
                like information on our retail mutual funds, please visit&nbsp;
                <a href={CTI_URL}>columbiathreadneedleus.com</a>&nbsp;to select
                our websites for individual investors or financial
                professionals.
              </p>

              <p className="u-sm-textSizeMsrm1">
                This site is for informational purposes and does not constitute
                an offer to sell or provide a solicitation of an offer to buy
                any security that may be referenced. The information contained
                on this site does not, in any way, constitute investment advice.
              </p>

              <p className="u-sm-textSizeMsrm1">
                <span className="u-textBold">
                  This site is intended for U.S. residents only.
                </span>{' '}
                Please read the&nbsp;
                <a href={getRelativeBasePath() + '/user-agreement'}>
                  User Agreement
                </a>
                &nbsp;carefully before proceeding. The use of this website is
                governed by Minnesota state law and applicable federal U.S. law.
                It is not directed to any person in any jurisdiction where the
                publication or availability of the website is prohibited.
              </p>

              <p className="u-sm-textSizeMsrm1">
                By selecting <span className="u-textBold">I accept</span> below,
                I agree to be bound by the user agreement set forth on this
                website. CMIA reserves the right to change the terms and
                conditions at any time.
              </p>

              <div className="u-marginTop4gu">
                <input
                  type="checkbox"
                  id="private-check"
                  name="private-check"
                  checked={privateCheckSelected}
                  onChange={handleCheck}
                />
                <label htmlFor="private-check">
                  {' '}
                  I am using a private computer or device.
                </label>
              </div>
            </div>
            <hr />
            <div className="u-flex u-lg-flexAlignItemsCenter u-sm-flexCol u-md-flexCol u-lg-flexJustifyEnd u-marginTop5gu">
              <a
                className="u-sm-block u-textCenter"
                href={getRelativeBasePath() + '/investor-redirect'}
              >
                I do not accept
              </a>
              <button
                id="disclaimer-accept-button"
                className="button u-sm-block u-bgColorBrandDark u-marginLeft4gu u-sm-marginRight4gu u-sm-marginTop2gu u-md-marginRight4gu u-md-marginTop2gu u-textColorWhite"
                onClick={handleClick}
              >
                I accept
              </button>
            </div>
          </div>
        </div>
      </>
    )
  )
}
